import { default as MIUShareIcon } from '@material-ui/icons/ShareOutlined'
import React from 'react'

const Share = ({ ...rest }) => {
  return <MIUShareIcon {...rest} />
}

export default Share
